import { useQuery } from "@tanstack/react-query";
import { salaryMappingsSupplemmentsQuery } from "../../../../../api/index.js";
import { AgGridReact } from "ag-grid-react";
import { localeText } from "../../../../../actions/datagrid.js";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import "ag-grid-enterprise";
import { SettingsProcountorContext } from "../SettingsProcountorContext.jsx";
import { Alert } from "react-bootstrap";
import { getContextMenuItemsForMappings } from "../SettingsProcountor.constants.js";
import { useGetColumnsForBenefitMapping } from "./useGetColumnsForBenefitMapping.tsx";

const defaultColDef = {
  resizable: true,
  sortable: true,
  editable: true,
  singleClickEdit: true,
  flex: 1,
};

export const BenefitMapping = () => {
  const { t, i18n } = useTranslation();
  const gridRef = useRef(null);
  const { data: mappingsData } = useQuery(salaryMappingsSupplemmentsQuery);
  const columnDefs = useGetColumnsForBenefitMapping("PROCOUNTOR");
  const { benefitEditedCells, setBenefitEditedCells } = useContext(SettingsProcountorContext);

  const editCells = async (cell) => {
    const changedCells = [...benefitEditedCells];
    const editedCellIndex = benefitEditedCells.map(({ id }) => id).indexOf(cell.id);
    const editedCell = {
      id: cell.id,
      supplement: cell.supplement,
      supplementName: cell.supplementName,
      salaryTypeCode: cell.salaryTypeCode,
    };

    if (editedCellIndex > -1) {
      changedCells[editedCellIndex] = editedCell;
    } else {
      changedCells.push(editedCell);
    }
    setBenefitEditedCells(changedCells);
  };

  return (
    <div>
      <Alert className="w-auto d-inline-block">{t("benefitMapping.editInfo")}</Alert>
      <div className="ag-theme-material ag-event-mapping styles-ag mb-3" style={{ height: "500px", marginRight: "0" }}>
        <AgGridReact
          ref={gridRef}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowData={mappingsData}
          getRowId={(params) => {
            return String(params.data.id);
          }}
          localeText={localeText(i18n)}
          debug={import.meta.env.DEV}
          onCellValueChanged={(event) => {
            editCells(event.data);
          }}
          defaultExcelExportParams={{
            exportAsExcelTable: true,
          }}
          defaultCsvExportParams={{
            columnSeparator: ";",
          }}
          getContextMenuItems={getContextMenuItemsForMappings}
        />
      </div>
    </div>
  );
};
